<template>
    <div>

        <Dialog :visible.sync="exibirModal" header="Solicitações Pendentes" :modal="true" :style="{ width: '40vw' }" @hide="fechar">
            <div v-if="solicitacaoes.length > 0">
                <DataTable :value="solicitacaoes" :scrollable="true" scrollHeight="190px" :autoLayout="true"
                    class="p-datatable-sm p-datatable-striped">
                    <Column field="data" header="Data da Solicitação"></Column>
                    <Column field="tipo" header="Tipo da Solicitação"></Column>
                </DataTable>
            </div>
            <template #footer>
                <div class="p-d-flex p-jc-end">
                    <div>
                        <Button label="OK" icon="pi pi-times" class="p-button-secondary"
                            @click="exibirModal = false" />
                    </div>
                </div>
            </template>
        </Dialog>

    </div>
</template>
  
<script>
import SolicitacaoService from "@/service/SolicitacaoService.js";
import { exibirMensagem } from '@/global';

export default {
    solicitacaoService: null,
    props: {
        callback: Function,
    },
    data() {
        return {
            exibirModal: false,
            solicitacaoes: [],
        }
    },
    methods: {
        /**
         * 
         * 
         */
        processar(requisicao) {
            console.log(requisicao)
            this.solicitacaoService = new SolicitacaoService();            
            this.listarPendentesPorFuncionario(requisicao);
        },
        /**
        * 
        * @param {*} solicitacao 
        */
        listarPendentesPorFuncionario(requisicao) {
            let novaRequisicao = {
                dataInicio: requisicao.dataPonto,
                dataFinal: requisicao.dataPonto,
                idFuncionario: requisicao.idFuncionario
            };
            this.solicitacaoService.listarPendentesPorFuncionario(novaRequisicao)
                .then(resp => {
                    resp.data.forEach(sol => {
                        sol.data = this.formartarStrData(sol.data, 'BR')
                        this.solicitacaoes.push(sol);
                    });

                    this.exibirModal = true;
                })
                .catch(erro => { exibirMensagem(this, erro) });
        },       
        /**
         * 
         * @param {*} strData 
         * @param {*} formato 
         */
        formartarStrData(strData, formato) {
            if (formato == 'BR') {
                let partes = strData.split('-');
                return partes[2] + '/' + partes[1] + '/' + partes[0];
            }
            let partes = strData.split('/');
            return partes[2] + '-' + partes[1] + '-' + partes[0];
        },       
        /**
         * 
         */
        fechar() {
            this.exibirModal = false;
            this.solicitacaoes = []
        }
    }
}
</script>
  
<style scoped>
.input-readonly {
    background-color: #F2F2F2;
}
</style>